import React, { useState, useEffect } from 'react';
import AttachmentsCard from 'components/Cards/AttachmentsCard';
import ToggleDetail from 'components/ToggleDetail';
import { isBrowser } from "react-device-detect";
import AttachmentFormWrapper from 'components/Forms/AttachmentFormWrapper';
import { connect } from 'react-redux';
import { SetLoading } from "redux/actions/loadingActions";
import { get } from 'services';
import WarningNotiifcation from 'components/WarningNotification';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import Alerts from 'utils/alerts' 
import Navigation from "components/Navigation";
import ValidateToken from "components/ValidToken";

const modulePadding =  isBrowser ? '' : '';

const AttachmentsModule = ({user, isRequiredModuleReducer}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(true);
  const [displayForm, setDisplayForm] = useState(false);
  const [dniTypes, setDniTypes] = useState([]);

  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true)
        const response = await get(`PersonaDocumento/GetByPersonaId/${user.persona.id}`)
        user.persona.personaDocumentos = response.data

        if (user.persona.personaDocumentos && user.persona.personaDocumentos.length > 0 && user.persona.personaDocumentos.filter(x => x.estado != 0).length > 0) {
          if (isRequiredModuleReducer)
            setShowDetail(false);
          else 
            setShowDetail(true);
        } else {
          setShowDetail(false);
        }

        const dnis = await get(`DocumentoTipo`)
        setDniTypes(dnis.data)
        setDisplayForm(true)
      } catch (error) {
        Alerts.operationFail()
      } finally {
        setIsLoading(false)
      }
    })();
    return function cleanup() {
      setDisplayForm(false)
    };
  }, [])

  return (
    <>
      <ValidateToken/>
      <div className={modulePadding}>
        {
          isLoading &&
          <div className={'display-flex flex-direction-row flex-center'}>
              <Spinner 
                  animation="grow" 
                  variant="primary" 
                  className={'is-absolute center-spinner-vertically'} 
                  size="lg" />
          </div>
        }
      
        <ToggleDetail initState={showDetail} onToggleDetail={setShowDetail} label="Documentos adjuntos"/>
        { 
          showDetail ? 
          <div> 
            {
                displayForm && (
                  ( user.persona && 
                    user.persona.personaDocumentos && 
                    user.persona.personaDocumentos.length > 0 && 
                    user.persona.personaDocumentos.filter(x => x.estado == 1).length > 0) 
                  ? (
                    user.persona.personaDocumentos.filter(x => x.estado == 1).map((documento) => {
                      return <AttachmentsCard key={documento.id} dniTypes={dniTypes} documento={documento}/>
                    })
                  )
                  : <Form.Group as={Col} md="12">
                  <WarningNotiifcation message='No ha agregado ' enphasis='documentos adjuntos'/>
                </Form.Group>
                )
            }
            <Navigation beforeUrl="/jobAppliedInformation" />
          </div>
          : 
          <div> 
            <AttachmentFormWrapper />
          </div>
        }
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    isRequiredModuleReducer: state.isRequiredModuleReducer,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    SetLoading: (value) => dispatch(SetLoading(value))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsModule);